import React from "react";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { shouldMountQueryDevtools } from "./queryDevtoolsVisibility";
import "./queryDevtools.css";

/**
 * Scopes the devtools' quiet toggle (queryDevtools.css): the library offers
 * no prop to style its floating button, so the rule reaches it through this
 * frame and the library's own `tsqd-open-btn-container` class (#11422).
 */
export function QueryDevtoolsFrame({
  children,
}: {
  children: React.ReactNode;
}) {
  return <div className="fp-query-devtools">{children}</div>;
}

/**
 * The TanStack Query devtools, mounted everywhere but production. The
 * library's default entry also renders nothing outside a development build.
 */
export default function FpReactQueryDevtools() {
  if (
    !shouldMountQueryDevtools(
      import.meta.env.VITE_ENV,
      import.meta.env.VITE_DISABLE_DEVTOOLS
    )
  ) {
    return null;
  }

  return (
    <QueryDevtoolsFrame>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryDevtoolsFrame>
  );
}
